import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { ChevronLeft, User } from 'react-feather';
import { DatePicker } from 'antd';
import { useDispatch, useSelector } from 'react-redux';
import { setName, setDateOfBirth } from '../../store/slices/authSlice';
import { useTranslation } from 'react-i18next';
import dayjs from 'dayjs';
import 'dayjs/locale/fr';
import locale from 'antd/locale/fr_FR';
import 'antd/dist/reset.css';
import './FirstName.css';

const FirstName = ({ nextPath = '/auth/your-gender', backPath = '/auth/welcome-policy' }) => {
    const savedName = useSelector(state => state.auth.name);
    const savedDate = useSelector(state => state.auth.doB);
    const [firstName, setLocalFirstName] = useState(savedName || '');
    const [nameError, setNameError] = useState('');
    const [birthDate, setLocalBirthDate] = useState(savedDate ? dayjs(savedDate) : null);
    const [dateError, setDateError] = useState('');
    const navigate = useNavigate();
    const dispatch = useDispatch();
    const { t, i18n } = useTranslation();

    const getMaxDate = () => {
        return dayjs().subtract(18, 'year');
    };

    const getMinDate = () => {
        return dayjs().subtract(100, 'year');
    };

    const validateName = (name) => {
        if (name.trim().length < 4) {
            setNameError(t('firstName.errors.nameLength'));
            return false;
        }
        setNameError('');
        return true;
    };

    const validateAge = (date) => {
        console.log("Validate age:", date);
        if (!date) return false;
        const maxDate = getMaxDate();
        console.log("Max date:", maxDate);
        if (date.isAfter(maxDate)) {
            setDateError(t('firstName.errors.ageLimit'));
            return false;
        }
        setDateError('');
        return true;
    };

    const handleNameChange = (e) => {
        const name = e.target.value;
        setLocalFirstName(name);
        validateName(name);
    };

    const handleDateChange = (date) => {
        setLocalBirthDate(date);
        validateAge(date);
    };

    const handleNext = () => {
        if (validateName(firstName) && birthDate && validateAge(birthDate)) {
            dispatch(setName(firstName.trim()));
            dispatch(setDateOfBirth(birthDate.toISOString()));
            navigate(nextPath);
        }
    };

    return (
        <div className="page-wrapper">
            <div className="page-content">
                <div className="container">
                    <div className="account-area style-2">
                        {/* Retour vers l'étape précédente de la logique du parcours (pas l'historique du navigateur : */}
                        {/* la redirection automatique de ProtectedAuthRoute peut remplacer l'historique réel) */}
                        <a href="#" onClick={(e) => { e.preventDefault(); navigate(backPath); }} className="back-btn">
                            <ChevronLeft className="icon" />
                        </a>
                        <div className="section-head ps-0">
                            <h2>{t('firstName.title')}</h2>
                        </div>
                        <div className={`mb-2 input-group input-group-icon input-mini ${nameError ? 'error' : ''}`}>
                            <div className="input-group-text">
                                <div className="input-icon">
                                    <User className="icon" />
                                </div>
                            </div>
                            <input 
                                type="text" 
                                className="form-control" 
                                placeholder={t('firstName.namePlaceholder')}
                                value={firstName}
                                onChange={handleNameChange}
                                aria-label={t('firstName.nameAriaLabel')}
                            />
                        </div>
                        {nameError && (
                            <div className="error-message mb-3">
                                {nameError}
                            </div>
                        )}
                        
                        <div className={`datepicker-container ${dateError ? 'error' : ''}`}>
                            <h6 className="mb-2">{t('firstName.birthdayTitle')}</h6>
                            <DatePicker
                                value={birthDate}
                                onChange={handleDateChange}
                                maxDate={getMaxDate()}
                                minDate={getMinDate()}
                                format="DD/MM/YYYY"
                                placeholder={t('firstName.birthdayPlaceholder')}
                         
                                locale={i18n.language === 'fr' ? locale : undefined}
                                className="w-100"
                                popupClassName="birthday-picker-dropdown"
                            />
                            {dateError && (
                                <div className="error-message">
                                    {dateError}
                                </div>
                            )}
                        </div>
                    </div>
                </div>
            </div>
            {/* Footer */}
            <div className="footer fixed bg-white p-b15">
                <div className="container">
                    <button 
                        onClick={handleNext}
                        className="btn btn-lg btn-gradient w-100 dz-flex-box btn-shadow rounded-xl"
                        disabled={!firstName.trim() || firstName.trim().length < 4 || !birthDate || dateError}
                    >
                        {t('firstName.next')}
                    </button>
                </div>
            </div>
        </div>
    );
};

export default FirstName;
